// extracted by mini-css-extract-plugin
export var avatarContainer = "_i9-0";
export var avatarTypingWave = "_i9-i";
export var gray = "_i9-f";
export var green = "_i9-c";
export var icon = "_i9-9";
export var image = "_i9-1";
export var lg = "_i9-6";
export var md = "_i9-5";
export var presenceDot = "_i9-b";
export var red = "_i9-d";
export var sm = "_i9-4";
export var status = "_i9-a";
export var typingDot = "_i9-h";
export var typingPill = "_i9-g";
export var xl = "_i9-7";
export var xs = "_i9-3";
export var xxl = "_i9-8";
export var xxs = "_i9-2";
export var yellow = "_i9-e";